let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fXqh3")).then(() => parcelRequire('eQ5x7'));